import {FETCH_USERS,} from '../actions/types/index';

export const userReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_USERS:
            return {list: action.payload, ...state};
        default:
            return state;
    }
}